import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";
import { uploadImages } from "../../utils/uploadFiles";

const getOrders = () => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.ORDERS);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.ORDERS,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const fetchOrderDetails = (id, returnData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.ORDER + id);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            dispatch({
                type: types.ORDER_DETAILS,
                payload: res.data,
            });
            if (returnData) {
                returnData(res.data);
            }
        }
    }
    dispatch(hideLoaderAction());
};

const updateOrderStatus = (id, data, history) => async (dispatch) => {
    dispatch(showLoaderAction());

    const orderData = { ...data };
    for (let key in orderData) {
        if (key === "images" || key === "reWorks") {
            for (let img of orderData[key]) {
                if (Array.isArray(img.afterImage) && img.afterImage.length) {
                    if (img.afterImage[0] instanceof File) {
                        const image = await uploadImages(img.afterImage);
                        img.afterImage = image[0] ?? "";
                    } else {
                        img.afterImage = img.afterImage[0] ?? "";
                    }
                }
            }
        }
    }

    const res = await api("put", Constants.END_POINT.ORDER_STATUS + id, { ...orderData });

    if (res.success) {
        if (res.data) {
            history.push("/orders");
            dispatch(showToast({ severity: "success", summary: res.message }));
        }
    }
    dispatch(hideLoaderAction());
};

export { getOrders, fetchOrderDetails, updateOrderStatus };
